export const NGO_BY_ID = "/v2/ngo-info";
export const MAIN_NGO = "/v2/ngo-main-info";
export const BANK_ACCOUNTS = "/v2/bank-accounts";
export const BANK_ACCOUNT_BY_ID = (id) => `/v2/bank-accounts/${id}`;
export const CONTACT_INFO = "/v2/contact-information";
export const CONTACT_INFO_BY_ID = (id) => `/v2/contact-information/${id}`;
export const STATUS = "/v2/service-status";
export const NGO_SERVICES = "/v2/ngo-services";
export const SERVICES = "/v2/services";
export const NGO_SERVICE_BY_ID = (id) => `/v2/ngo-services/${id}`;
export const SERVICE_FREQUENCY = "/v2/service-frequencies";
export const SERVICES_AND_CLASSIFICATIONS = "/v2/classification-ngos";
export const CLASSIFICATIONS = "/v2/ngo-classifications";
export const NGO_CLASSIFICATIONS = "/v2/classification-ngos";
export const NGO_CLASSIFICATIONS_BY_ID = (id) =>
  `/v2/classification-ngos/${id}`;
export const SERVICE_TYPES = "/v2/service-types";
export const BRANCHES = "/v2/branch";
export const BRANCH_BY_ID = (id) => `/v2/branch/${id}`;
export const DOCS = (slug) => `/v2/guest/instructions/slug/${slug}`;
export const SERVICE_CENTRES = `/v2/service-centres`;
export const SERVICE_CENTRES_BY_ID = (id) => `/v2/service-centres/${id}`;
export const CREATE_BANK_ACCOUNTS_DRIVERS = `/v2/manager-accounts`;
export const BANK_ACCOUNTS_DRIVERS_BY_id = (id) => `/v2/manager-accounts/${id}`;
export const GET_BANK_ACCOUNTS_DRIVERS = (id) => `/v2/manager-accounts/${id}`;
export const LOGO = "/v2/ngo-logo";
export const LOGS = `/v2/logs`;
export const NOTIFICATIONS = `/v2/notifications`;

export const DOC_BY_KEY = (key) => `/v2/ngo-info/${key}`;
export const MAIN_HQ = `/v2/ngo-main-hq`;
export const CONFIRM_INFO = `/v2/ngo-complete`;
export const PROFILE_SCORE = `v2/weights`;
